import React, { Component } from 'react'
import { NameContainer } from '../../Commons/Name'
import { GregorianContainer } from '../../Commons/DateCalendars/Gregorian'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { translateFormFieldLabel } from '../../../../../../../helpers/collaborativeIndexations'

class Identity extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
    }

    constructor()
    {
        super()

        this.updateProfession = this.updateProfession.bind(this)
    }

    updateProfession(event)
    {
        this.props.updateFieldValue('profession', event.target.value)
    }

    render()
    {
        const { t, fields } = this.props

        return (
            <div>
                <div>
                    { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.nominative_with_date.steps.identity.title') }
                    <NameContainer hasFocus={true} />
                </div>
                <div className={'form-group calendars'}>
                    <label>{translateFormFieldLabel(t, 'birthDate')}</label>
                    <GregorianContainer fieldName={'birthDate'}/>
                </div>
                <div className={'form-group'}>
                    <label htmlFor={'profession'}>{translateFormFieldLabel(t, 'profession')}</label>
                    <input id={'profession'} defaultValue={fields.profession} onChange={this.updateProfession} type={'text'}/>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Identity)
